import { render, staticRenderFns } from "./craft.vue?vue&type=template&id=4f47ba42&lang=pug"
import script from "./craft.vue?vue&type=script&lang=coffee"
export * from "./craft.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/opt/build/repo/site/components/globals/btn/btn.vue').default})
